module.exports = __webpack_public_path__ + "src/assets/img/van.e6f3a0df.svg";